//权限资源

const state = {
    routes: []
}

const mutations = {
    SET_PERMISSION (state, permission) {
        state.routes = permission
    }
}

const actions = {
    SET_PERMISSION (context, permission) {
        context.commit("SET_PERMISSION", permission)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}